import { useAtomValue } from 'jotai';
import { latestFundingsByCompanyState } from '../../../state/CompanyFundingsState';
import { selectedCompanyIdProfileAtom } from '../../../state/UIStateJ';
import { FMT } from '../../../../../util/formatter-service';
import { LabeledField } from '../../../../../components/LabeledField';

export function PostMoneyValuationField() {
  const companyId = useAtomValue(selectedCompanyIdProfileAtom);
  const latestNonNull = useAtomValue(latestFundingsByCompanyState(companyId));

  const { valuationInMillions, dealDate } = latestNonNull ?? {};

  return (
    <LabeledField
      label={'Latest Post Money'}
      description={dealDate ? FMT.format('date', dealDate) : undefined}
      value={valuationInMillions != null ? FMT.format('currencyShort', valuationInMillions * 1_000_000) : '-'}
    />
  );
}
